import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-inline-message',
  templateUrl: './inline-message.component.html',
  styleUrl: './inline-message.component.scss'
})
export class InlineMessageComponent {
    @Input() icon: boolean = false;
    @Input() iconFontSize: string = "30px";
    @Input({ required: true }) type: 'warning' | 'danger' | 'success';
    @Input({ required: true }) message: string;

    getIcon() {
        const iconMapper: Record<typeof this.type, string> = {
            warning: 'uii-warning',
            danger: 'uii-warning',
            success: 'uii-circle-check'
        }

        return iconMapper[this.type];
    }
}
